let configuration;

const initConfig = () => {
  const config = {
    googleMap: import.meta.env.VITE_GOOGLE_MAP_API_KEY,
    googleClientID: import.meta.env.VITE_GOOGLE_CLIENT_ID,
    appDomainUrl: import.meta.env.VITE_APP_BASE_URL,
    aiDomainUrl: import.meta.env.VITE_APP_AI_BASE_API_URL,
    videoPath: import.meta.env.VITE_APP_VIDEO_PATH,
    cdnAssetUrl: import.meta.env.VITE_CDN_ASSET_URL
  };

  return config;
};

const getConfig = () => {
  if (!configuration) {
    configuration = initConfig();
  }
  return configuration;
};

export { getConfig };
